class PostCodeAutocompleteController {
    /*@ngInject*/
    constructor(locationService, postcode, $scope) {
        this.locationService = locationService;
        this.postcode = postcode;
        this.$scope = $scope;
    }

    $onInit() {
        this.POSTCODE_MIN_LENGTH_FOR_AUTOCOMPLETE = this.postcode.POSTCODE_MIN_LENGTH_FOR_AUTOCOMPLETE;
        this.POSTCODE_SEARCH_RESULTS_LIMIT = this.postcode.POSTCODE_SEARCH_RESULTS_LIMIT;

        this.isLoading = false;

        this.$scope.$watch(() => this.address, (newValue, oldValue) => {
            this.displayValue = this.suburbAndPostcodeDisplayName(this.address);
        }, true);
    }

    suburbAndPostcodeDisplayName(address) {

        if(address === null || address.length === 0) {
            return '';
        }

        return address.suburb + ' ' + address.postCode + ', ' + address.state;
    }

    performSearchForSuburb(postCode) {

        if(!postCode || postCode.length < this.POSTCODE_MIN_LENGTH_FOR_AUTOCOMPLETE) {

            return [];
        }

        var _self = this;
        _self.isLoading = true;

        var locations = this.locationService.typeAheadSearchForPostcode(postCode, this.POSTCODE_SEARCH_RESULTS_LIMIT).then(
            function(result) {
                _self.isLoading = false;
                return result;
            }
        ).catch(function(error) {
            _self.isLoading = false;
        });

        return locations;
    }

    setDeliveryPostcodeAddress(address) {

        this.address = address;
    }

    postcodeInvalid() {

        if((typeof this.displayValue === 'undefined')) {
            return true;
        }

        // delivery postcode will only be invalid if user choose to ignore auto completion and ignore auto completion
        return this.displayValue.trim() !== this.suburbAndPostcodeDisplayName(this.address).trim();
    }
}

export default PostCodeAutocompleteController;


// WEBPACK FOOTER //
// ./src/app/common/postcode/postcode-autocomplete.controller.js